import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
import './style.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);